export default __webpack_public_path__ + "static/media/increase.618585f4.svg";